import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, FieldWrapper, Button } from '../src';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "fieldwrapper"
    }}>{`FieldWrapper`}</h1>
    <blockquote>
      <p parentName="blockquote">{`This component is here for edge cases where you get the state from another component and you have to pass it to the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component manually, e.g. third party components.`}</p>
    </blockquote>
    <p>{`This component has to be a child within the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component. This component exposes three additional props to its child component so that you are able to use third party components.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  Form,
  FieldWrapper,
} from 'react-form-package';
`}</code></pre>
    <p>{`Render a `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` with an `}<inlineCode parentName="p">{`<FieldWrapper />`}</inlineCode>{` and a `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component.`}</p>
    <p>{`Take a look into the `}<a parentName="p" {...{
        "href": "/react-form-package/third-party-components"
      }}>{`Third Party Components Section`}</a>{` to see how you can use this component properly.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`  <Form>
    <div>
      <FieldWrapper type="text" id="fieldwrapper">
        {/*
          Render a child component that gets access to

          onFocus
          onBlur
          onChange
        */}
      </FieldWrapper>
    <div>
      <Button id="submit" type="submit" onClick={(state) => {
        alert(JSON.stringify(state, null, 2));
        alert('open the console to see the whole state...');
        console.log(state);
      }}
      >Submit</Button>
    </div>
  </Form>
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property `}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id `}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`checkbox`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`datetime-local`}</inlineCode>{`, `}<inlineCode parentName="td">{`email`}</inlineCode>{`, `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`tel`}</inlineCode>{`, `}<inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`, `}<inlineCode parentName="td">{`time`}</inlineCode>{`, `}<inlineCode parentName="td">{`url`}</inlineCode>{`, `}<inlineCode parentName="td">{`file`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`required`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`min`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: has to have at least `}<inlineCode parentName="td">{`min`}</inlineCode>{` characters; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: has to be at least `}<inlineCode parentName="td">{`min`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`max`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: has to have at least `}<inlineCode parentName="td">{`min`}</inlineCode>{` characters; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: has to be at least `}<inlineCode parentName="td">{`min`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`RegEx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the input value has to match the `}<inlineCode parentName="td">{`regular expression`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sameAs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{` the input value has to have the same value as the input field with the id specified in `}<inlineCode parentName="td">{`sameAs`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`preOnChange`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Func `}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false `}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`manipulate the state before its validated (see `}<a parentName="td" {...{
              "href": "/react-form-package/state-manipulation"
            }}>{`State Manipulation`}</a>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorMessage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`define your own custom error message for the input`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "props-that-get-exposed-to-the-child-component"
    }}>{`Props that get exposed to the child component`}</h2>
    <p>{`To see how you can use this properties take a look at `}<a parentName="p" {...{
        "href": "/react-form-package/third-party-components"
      }}>{`Third Party Components`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property `}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onFocus`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Func`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pass your `}<inlineCode parentName="td">{`value`}</inlineCode>{` to this function to update the state of the `}<inlineCode parentName="td">{`<Form />`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onChange`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Func`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pass your `}<inlineCode parentName="td">{`value`}</inlineCode>{` to this function to update the state of the `}<inlineCode parentName="td">{`<Form />`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onBlur`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Func`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pass your `}<inlineCode parentName="td">{`value`}</inlineCode>{` to this function to update the state of the `}<inlineCode parentName="td">{`<Form />`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`meta`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`get access to the state of the `}<inlineCode parentName="td">{`<FieldWrapper />`}</inlineCode>{` component (see `}<a parentName="td" {...{
              "href": "/react-form-package/state"
            }}>{`State`}</a>{`)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      